module.exports = __webpack_public_path__ + "img/yellow-glow.2007c75f.svg";